import { AxiosResponse } from 'axios';
import { IBaseApiRequest } from '@api';
import {
  IDirectoryItem,
  IDirectoryItemsFilters,
  IPaginated,
  PaginationMeta,
} from '@entities';
import { getSorterParamsForApi } from '@functions';
import { ICountry } from '../../entities/Country';

interface IGetAll extends IBaseApiRequest, IDirectoryItemsFilters, IPaginated {
  attribute?: string;
  direction?: string;
}
export async function getAll({
  api,
  offset,
  limit,
  attribute,
  direction,
}: IGetAll) {
  let params = {
    ...getSorterParamsForApi({ attribute, direction }),
    offset,
    limit,
  };

  let response = (await api.get('countries', {
    params,
  })) as AxiosResponse<{
    data: { data: ICountry[] };
    meta: PaginationMeta;
  }>;

  return response.data.data.data;
}
